import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import {Provider} from "react-redux";
import rootReducerAndStore from "./root-reducer-and-store";
import {LoadingIndicator} from "./views/LoadingIndicator";

const store = rootReducerAndStore();

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
        <Provider store={store}>
            <App />
            <LoadingIndicator/>
        </Provider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

reportWebVitals();
